export function formatWalletAddress(
  walletAddress: string | undefined | null,
  startChars: number = 8,
  endChars: number = 3
): string | null {
  if (!walletAddress) {
    return null;
  }

  if (walletAddress.length <= startChars + endChars) {
    return walletAddress;
  }

  const start = walletAddress.slice(0, startChars);
  const end = walletAddress.slice(-endChars);
  return `${start}...${end}`;
}

export function renderMetaPubkey(v: string, max = 30) {
  return v.length < max ? v : `${v.slice(0, max - 3)}...${v.slice(-3)}`;
}
